// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M12 10.8L8.1 14.7Q7.82 14.98 7.4 14.98T6.7 14.7 6.42 14 6.7 13.3L11.3 8.7Q11.6 8.4 12 8.4T12.7 8.7L17.3 13.3Q17.58 13.58 17.58 14T17.3 14.7 16.6 14.98 15.9 14.7Z"/>';

/** Chevron Up (arrows). */
const icon: IconData = {
  id: "chevron-up",
  name: "Chevron Up",
  category: "arrows",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M12 10.8L7.4 15.4 6 14 12 8 18 14 16.6 15.4Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M12 10.8L8.1 14.7Q7.82 14.98 7.4 14.98T6.7 14.7 6.42 14 6.7 13.3L11.3 8.7Q11.6 8.4 12 8.4T12.7 8.7L17.3 13.3Q17.58 13.58 17.58 14T17.3 14.7 16.6 14.98 15.9 14.7Z"/></g><path d="M12 10.8L8.1 14.7Q7.82 14.98 7.4 14.98T6.7 14.7 6.42 14 6.7 13.3L11.3 8.7Q11.6 8.4 12 8.4T12.7 8.7L17.3 13.3Q17.58 13.58 17.58 14T17.3 14.7 16.6 14.98 15.9 14.7Z"/>',
    },
  },
  animation: () => import("../animations/chevron-up.js"),
};

export default icon;
